import flags from '../constants/flags';
import { languageToCountryMapping } from '../constants/languageToCountryMapping';

// Helper function to get country flag by country code
export const getCountryFlagByCode = (countryCode: string) => {
  const flagData = Object.values(flags).find((flag: any) => flag.code === countryCode);
  return flagData;
};

// Helper function to get country flag by language code
export const getCountryFlagByLanguage = (languageCode: string) => {
  const countryCode = languageToCountryMapping[languageCode];
  if (!countryCode) {
    // Default to US flag if no mapping found
    return getCountryFlagByCode('US');
  }
  return getCountryFlagByCode(countryCode);
};

// Helper function to get current language from Google Translate
export const getCurrentLanguage = () => {
  const selectElement = document.querySelector('.goog-te-combo') as HTMLSelectElement;
  return selectElement?.value || 'en';
};
